import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const offerings = [
  { label: 'Fractional Head of Data & AI', path: '/offerings#fractional' },
  { label: 'Advise', path: '/offerings#pillar-01' },
  { label: 'Strategy & Program', path: '/offerings#pillar-02' },
  { label: 'Data & Platform', path: '/offerings#pillar-03' },
  { label: 'Build & Deploy', path: '/offerings#pillar-04' },
  { label: 'Adopt, Operate & Hand Over', path: '/offerings#pillar-05' },
];

export const OfferingsDropdown = ({ isOpen, onClose, isMobile, onMouseEnter, onMouseLeave }) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) onClose();
    };
    if (isOpen && !isMobile) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose, isMobile]);

  useEffect(() => {
    const handleEsc = (event) => { if (event.key === 'Escape') onClose(); };
    if (isOpen && !isMobile) document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen, onClose, isMobile]);

  const handleItemClick = () => setTimeout(() => onClose(), 50);

  if (!isOpen) return null;

  return (
    <div
      ref={dropdownRef}
      id={isMobile ? 'mega-offerings-mobile' : 'mega-offerings'}
      className={`mining-dropdown ${isMobile ? 'mining-dropdown-mobile' : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role="menu"
      aria-label="Offerings menu"
      data-testid="offerings-dropdown"
    >
      <div className="mining-dropdown-grid" style={{ gridTemplateColumns: '280px' }}>
        <div className="mining-category-column">
          <h4 className="mining-category-title">Offerings</h4>
          <ul className="mining-subitems-list">
            {offerings.map((item, i) => (
              <li key={item.label}>
                <Link to={item.path} className="mining-subitem-link" onClick={handleItemClick} role="menuitem">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OfferingsDropdown;
